// M7 — Manager tour: Products. 3 steps on /components.
export default {
  key: 'M7',
  route: '/components',
  steps: [
    {
      id: 'reusable',
      target: '[data-tour-id="products.list"]',
      title: 'Products',
      desc: 'Products (also called components or details) are reusable definitions shared across orders and inquiries.',
    },
    {
      id: 'nested',
      target: '[data-tour-id="products.list"]',
      title: 'Nested components',
      desc: 'Each product can be composed of sub-components forming a bill of materials — visible when you open a product.',
    },
    {
      id: 'execution',
      target: '[data-tour-id="products.list"]',
      title: 'Execution & materials',
      desc: 'Each product defines its production operations (actions) and the raw materials it consumes — visible inside the product detail.',
    },
  ],
}
